import PropTypes from "prop-types";

/**
 * DTO (schema) pour la soumission de formulaire propriétaire
 * Ce fichier expose à la fois une représentation JS simple et une forme PropTypes
 * Utilisez `OwnerLeadPropTypes` pour valider un objet côté React
 */
export const OwnerLeadDto = {
  propertyType: "string",
  surface: "string",
  rooms: "string",
  postalCode: "string",
  isOwner: "string",
  furnished: "string",
  available: "string",
  works: "string",
  civility: "string",
  firstName: "string",
  lastName: "string",
  phone: "string",
  email: "string",
  source: "string",
  userInfos: "string",
  timestamp: "string",
};

export const OwnerLeadPropTypes = PropTypes.shape({
  propertyType: PropTypes.string.isRequired,
  surface: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rooms: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  postalCode: PropTypes.string.isRequired,
  isOwner: PropTypes.string.isRequired,
  furnished: PropTypes.string.isRequired,
  available: PropTypes.string.isRequired,
  works: PropTypes.string.isRequired,
  civility: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  source: PropTypes.string,
  userInfos: PropTypes.string,
  timestamp: PropTypes.string,
});

/**
 * DTO pour le formulaire court (banner)
 */
export const ShortLeadDto = {
  name: "string",
  phone: "string",
  email: "string",
  source: "string",
};

export const ShortLeadPropTypes = PropTypes.shape({
  name: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  source: PropTypes.string,
});

export default {
  OwnerLeadDto,
  OwnerLeadPropTypes,
  ShortLeadDto,
  ShortLeadPropTypes,
};
